(function($) {

  var $toggleFlightStop = $('.js-flight-stop-toggle');

  $toggleFlightStop.click(function(){
    $(this).toggleClass('is-active');
  });

})(jQuery);